export default __webpack_public_path__ + "static/media/tower.1819fe9f.jpeg";